module.exports = __webpack_public_path__ + "static/media/06.2849e2c4.jpg";